@if (desktopView) {
  <div class="dashboard-item">
    @if (!definition.hasMenu) {
      <a routerLink="{{ definition.href }}">
        <i class="icon {{ definition.icon }}"></i>
        {{ definition.header | translate }}
      </a>
    }
    @if (definition.hasMenu) {
      <a class="position-relative">
        @if (updates) {
          <div class="updates">{{ updates }}</div>
        }
        <i class="icon {{ definition.icon }}"></i>
        {{ definition.header | translate }}
      </a>
    }
    @if (showMenu) {
      <div class="menu-container">
        <span class="arrow-left"></span>
        <ul appDashboardItemMenu class="dashboard-menu">
          @for (item of definition.menuDefinition; track item) {
            <li>
              <a routerLink="{{ item.href }}" (click)="onSubMenuClick()"
                ><i class="menu-item-i"></i><span class="menu-item-caption">{{ item.caption | translate }}</span></a
                >
              </li>
            }
          </ul>
        </div>
      }
    </div>
  }
  @if (mobileView) {
    <div>
      <button (click)="openMenu()" class="menu-m-btn">
        <i class="icon-m {{ definition.icon }}"></i><span class="dashboard-item-name-m ml-40">{{ definition.header | translate }}</span>
      </button>
      @if (showMenu) {
        <ul class="dashboard-item-menu-m ml-40">
          @for (item of definition.menuDefinition; track item) {
            <li>
              <a routerLink="{{ item.href }}" (click)="onSubMenuClick()"><i class="d-inline-block mr-2">-</i>{{ item.caption | translate }}</a>
            </li>
          }
        </ul>
      }
    </div>
  }
